import React from 'react'
import SuperUserLoanPageUI from '../../../templates/SuperUserLoanPageUI.js'
import GenericErrorUI from '../../../components/common/GenericErrorUI'
import LoanFeasibilitySF from '../../../components/superUser/loan/assessment/LoanFeasibilitySF'
import SpinnerComponentUI from '../../../components/common/SpinnerComponentUI'

const LoanFeasibilityPageUI = ({ context, errorList, loan, account, loanFeasibility, feasibilityItemList, onRefreshClick,
  onInternalRemarksClick, internalRemarksMode, onCancelRemarksClick, objectId, selectedRemarks,
  externalRemarksMode, onExternalRemarksClick,
  onShowDetails, showDetailsMode, toggleEditable, editable,
}) =>
  <SuperUserLoanPageUI context={context} className='pg_su_feas'
    backLink={`/su/${loan && loan.status === 'closed' ? 'closedLoans' : 'loans'}`}
    headerText={loan ? (loan.account.accountName + ' ' + (loan.loanName || '')) : 'Loan'}
    centered={!loan || !errorList || !loanFeasibility} loan={loan} page='feasibility'
    dimension='w768'
  >
    {
      (!loan && !errorList || !loanFeasibility) &&
      <SpinnerComponentUI />
    }
    {
      errorList && errorList.length > 0 &&
      <GenericErrorUI error={errorList[0]} />
    }
    {
      loan && loanFeasibility &&
      <LoanFeasibilitySF
        context={context}
        loan={loan}
        account={account}
        loanFeasibility={loanFeasibility}
        feasibilityItemList={feasibilityItemList}
        onRefreshClick={onRefreshClick}
        //
        onInternalRemarksClick={onInternalRemarksClick}
        internalRemarksMode={internalRemarksMode}
        //
        onExternalRemarksClick={onExternalRemarksClick}
        externalRemarksMode={externalRemarksMode}
        onCancelRemarksClick={onCancelRemarksClick}
        objectId={objectId}
        selectedRemarks={selectedRemarks}
        onShowDetails={onShowDetails}
        showDetailsMode={showDetailsMode}
        toggleEditable={toggleEditable}
        editable={editable}
      />
    }
  </SuperUserLoanPageUI>

export default LoanFeasibilityPageUI